// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2EQWe","addWidgetButton":"Header_addWidgetButton__39t7n","dashboardTabs":"Header_dashboardTabs__3fqEI","active":"Header_active__29X3D"};